import React, { Component } from "react";
import PropTypes from "prop-types";
import { format } from "d3-format";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor, isDefined } from "../utils";

class SupportResistanceTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }

  renderSVG(moreProps) {
    const {
      className,
      fontFamily,
      fontSize,
      textFill,
      labelFill,
      supportFill,
      resistanceFill,
      displayFormat,
      yAccessor,
      onClick,
      origin: originProp,
      displayValuesFor,
    } = this.props;

    const origin = functor(originProp);
    const {
      chartConfig: { width, height },
    } = moreProps;
    const [x, y] = origin(width, height);

    const currentItem = displayValuesFor(this.props, moreProps);
    let supportText = "n/a";
    let resistanceText = "n/a";

    if (isDefined(currentItem) && isDefined(yAccessor(currentItem))) {
      const item = yAccessor(currentItem);
      if (isDefined(item?.support)) {
        supportText = displayFormat(item.support);
      }
      if (isDefined(item?.resistance)) {
        resistanceText = displayFormat(item.resistance);
      }
    }

    const label = "Support & Resistance: ";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-support-resistance"
      >
        <ToolTipText
          fontFamily={fontFamily}
          fontSize={fontSize}
          fill={textFill}
        >
          <ToolTipTSpanLabel fill={labelFill}>{label}</ToolTipTSpanLabel>
          <tspan fill={supportFill}>S: {supportText}</tspan>
          <tspan fill={textFill}> | </tspan>
          <tspan fill={resistanceFill}>R: {resistanceText}</tspan>
        </ToolTipText>
      </g>
    );
  }

  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

SupportResistanceTooltip.propTypes = {
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  className: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  supportFill: PropTypes.string,
  resistanceFill: PropTypes.string,
  displayFormat: PropTypes.func,
  displayValuesFor: PropTypes.func,
  onClick: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
};

SupportResistanceTooltip.defaultProps = {
  origin: [0, 0],
  className:
    "react-stockcharts-tooltip react-stockcharts-support-resistance-tooltip",
  displayFormat: format(".2f"),
  displayValuesFor,
  labelFill: "#6B7280",
  textFill: "#F9FAFB",
  supportFill: "#80c080",
  resistanceFill: "#80c080",
};

export default SupportResistanceTooltip;
